<template>
    <div v-if="computedBusy" class="text-center d-flex h-100">
        <div class="d-flex flex-fill justify-content-center align-items-center">
            <div>
                <b-spinner :variant="localVariant" class="mr-2" v-if="!error"></b-spinner>
                <i class="fa-solid fa-exclamation-triangle fa-2x fa-fw text-danger" v-else></i>
                <div class="align-middle" :class="textClass" v-if="loadingText">{{ loadingText }}</div>
                <div class="align-middle font-xs font-italic" v-if="heavyDataLoad">This report contains a large amount of data and may take some time to load.</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LoadingSpinner',
    props: {
        busy: {
            type: Boolean,
            default: false,
        },
        text: {
            type: String,
            default: 'Loading...',
        },
        textClass: {
            type: String,
            default: '',
        },
        variant: {
            type: String,
            default: 'primary',
        },
        heavyDataLoad: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            localBusy: false,
            loadingText: this.text,
            messageDelay10: null,
            messageDelay30: null,
            messageDelay2min: null,
            error: false,
            localVariant: this.variant,
        };
    },
    mounted() {
        // Start 10 sec message timer
        this.messageDelay10 = setTimeout(() => {
            if (this.loadingText) {
                this.loadingText = 'Still working...';
            }
            clearTimeout(this.messageDelay10);

            // Start 30 sec message timer
            this.messageDelay30 = setTimeout(() => {
                if (this.loadingText) {
                    this.loadingText = 'Taking a while...';
                }
                this.localVariant = 'warning';
                clearTimeout(this.messageDelay30);

                // Start 2 min message timer
                this.messageDelay2min = setTimeout(() => {
                    if (this.loadingText) {
                        this.loadingText = 'Something might be wrong, try refreshing.';
                    }
                    this.error = true;
                    clearTimeout(this.messageDelay2min);
                }, 100000);
            }, 20000);
        }, 10000);
    },
    beforeDestroy() {
        // Unset timers
        clearTimeout(this.messageDelay10);
        clearTimeout(this.messageDelay30);
        clearTimeout(this.messageDelay2min);
    },
    computed: {
        computedBusy() {
            return this.busy || this.localBusy;
        }
    }
};
</script>

<style scoped>

</style>
